/**
 * Dashboard 服务模块：获取用户端统计数据
 */

import { apiService } from './api'
import type { UserDashboardStats } from '@/types/dashboard'

/**
 * API 响应结构
 */
interface ApiResponseWrapper<T> {
  code: number
  message: string
  data: T
}

const DASHBOARD_ENDPOINT = '/api/user/dashboard' as const

/**
 * 获取用户端 Dashboard 统计
 * @returns Dashboard 统计数据
 */
export async function getDashboardStats(): Promise<UserDashboardStats> {
  const response = await apiService.get<ApiResponseWrapper<UserDashboardStats>>(
    `${DASHBOARD_ENDPOINT}/stats`
  )
  return response.data
}
